import {Container, AppBar } from '@mui/material';
import {React,useEffect} from 'react'
import Footer from '../footer/Footer';
import { useParams } from "react-router-dom";
import Article from "./Article1.png"

// import BannerImg from './bannerimg/BannerImg'
// import TrendingTopics from './trendingtopics/TrendingTopics'
// import SearchBox from './searchbox/Searchbox'
// import GuideCards from './guidecards/GuideCards'
// import Tools from './tools/Tools'
// import VideoTutorial from './videotutorial/VideoTutorial'
// import YoutubePlayer from './youtubeplayer/YoutubeVideos'
// import YoutubeVideos from './youtubeplayer/YoutubeVideos'
//import InfoVideos from './videotutorial/InfoVideos'


const headingStyle = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '16px',
  color :'#221F1F',
  lineHeight: '36px',
};

const titleStyle = {
  fontFamily: 'Inter',
  fontWeight: 700,
  fontSize: '32px',
  color:"#31B9B5",
  lineHeight: '53.25px',
}; 
const paragraphStyle = {
  fontFamily: 'DM Sans',
  fontWeight: 400,
  fontSize: '16px',
  color:'#222222BF',
  lineHeight: '40.73px',
  textAlign: 'justify',

};
 
const Heading = ({ level, text }) => {
  const HeadingComponent = `h${level}`;

  return <HeadingComponent style={headingStyle}>{text}</HeadingComponent>;
};

const Paragraph = ({ text }) => {
  return <p style={paragraphStyle}>{text}</p>;
};


const Title = ({ level, text }) => {
  const HeadingComponent = `h${level}`;

  return <HeadingComponent style={titleStyle}>{text}</HeadingComponent>;
};

const MortgageApplication = () => {

  
  return (
    <Container maxWidth="xl" className="articleContainer">
    
    <div >
<img src={Article} alt="Article 1" style={{  maxWidth: '100%', height: 'auto', marginTop: '50px'}} />



      <Title level={1} text="Preparing for the Application"  />

      <Heading level={2} text="Personal Information" />
      <Paragraph text="Provide your full name, contact information, date of birth, and Social Security number. Include information about your marital status and the number of dependents you have." />

      <Heading level={2} text="Employment History" />
      <Paragraph text="List your current and previous employers, including the company name, your job title, the dates of employment, and your income details. Provide documentation such as pay stubs, W-2 forms, or tax returns to verify your income." />

      <Heading level={2} text="Financial Information" />
      <Paragraph text="Gather your financial documents, including bank statements, investment statements, and retirement account statements. Include documentation on any outstanding loans or debts you have, such as credit card statements or student loan statements." />

      <Heading level={2} text="Credit History" />
      <Paragraph text="Request a copy of your credit report from one of the major credit reporting agencies (Equifax, Experian, or TransUnion) and review it for accuracy. Address any errors before submitting your mortgage application. Be prepared to explain any negative items on your credit report and provide supporting documents if necessary." />

      <Heading level={2} text="Proof of Assets" />
      <Paragraph text="Compile documentation to verify your assets, such as bank account statements, investment account statements, and information about any real estate you own. This will help demonstrate your financial stability and ability to make a down payment." />

      <Heading level={2} text="Debt-to-Income Ratio" />
      <Paragraph text="Calculate your debt-to-income ratio, which compares your monthly debt payments to your gross monthly income. Include all recurring debts, such as credit card payments, car loans, and student loans. Lenders typically prefer a debt-to-income ratio below 43% to ensure you can comfortably manage your mortgage payments." />

      <Heading level={2} text="Property Information" />
      <Paragraph text="If you have already identified a property you wish to purchase, gather information about the property, such as the address, purchase price, and property type (e.g., single-family home, condominium). Include any additional details or disclosures required by the lender." />

      <Heading level={2} text="Mortgage Application Forms" />
      <Paragraph text="Obtain the necessary mortgage application forms from your chosen lender. These may include a loan application, a borrower's authorization form, and a disclosure form. Fill out the forms accurately and completely, providing all requested information." />

      <Heading level={2} text="Additional Documentation" />
      <Paragraph text="Be prepared to provide additional documentation as requested by the lender during the application process. This may include further proof of income, explanations for any large deposits or withdrawals in your bank accounts, or additional details on specific financial transactions." />

      <Heading level={2} text="Pre-approval Letter" />
      <Paragraph text="Consider getting pre-approved for a mortgage before submitting your application. A pre-approval letter from a lender shows sellers that you are a serious buyer and can help strengthen your offer." />

      <Paragraph text="It's essential to work closely with your chosen lender to understand their specific requirements and ensure you provide all the necessary information. By being organized and thorough in preparing your content for the mortgage application, you increase your chances of a successful approval process." />
    </div>
    </Container>
  );
};








const ArticlePage2 = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/*<img src={image} alt="Article" />
      <h1>{title}</h1>
      <p>{description}</p>*/}
     < MortgageApplication/>
    </div>
  );
};

export default ArticlePage2;